import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useResolveFieldglassIssueMutation } from 'queries/admin/fieldglass/useResolveFieldglassIssueMutation'

type FieldglassIssueActionsContextState = {
  state: {
    resolveFieldglassIssueMutationState: {
      isPending: boolean
      isError: boolean
      isSuccess: boolean
      errorMessage: string | undefined
      resolvingIssueId: number | undefined
    }
  }
  actions: {
    resolveFieldglassIssue: ReturnType<
      typeof useResolveFieldglassIssueMutation
    >['mutate']
    resetResolveFieldglassIssue: ReturnType<
      typeof useResolveFieldglassIssueMutation
    >['reset']
  }
}

const [Context, useFieldglassIssueActionsContextValue] =
  createContext<FieldglassIssueActionsContextState>({
    name: 'FieldglassIssueActionsContext',
  })

export const FieldglassIssueActionsProvider = ({
  children,
}: PropsWithChildren) => {
  const {
    mutate: resolveFieldglassIssue,
    isPending: isResolveFieldglassIssuePending,
    isError: isResolveFieldglassIssueError,
    isSuccess: isResolveFieldglassIssueSuccess,
    error: resolveFieldglassIssueError,
    variables: resolveFieldglassIssueVariables,
    reset: resetResolveFieldglassIssue,
  } = useResolveFieldglassIssueMutation()

  const value: FieldglassIssueActionsContextState = {
    state: {
      resolveFieldglassIssueMutationState: {
        isPending: isResolveFieldglassIssuePending,
        isError: isResolveFieldglassIssueError,
        isSuccess: isResolveFieldglassIssueSuccess,
        errorMessage: parseErrorMessage(resolveFieldglassIssueError),
        resolvingIssueId: isResolveFieldglassIssuePending
          ? resolveFieldglassIssueVariables?.issueId
          : undefined,
      },
    },
    actions: {
      resolveFieldglassIssue,
      resetResolveFieldglassIssue,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useFieldglassIssueActionsContextValue }
